export const CHART_TITLES = {
  JOBS_BY_STATUS: "Jobs by Status",
  JOBS_TO_GO: "Jobs to Go Today/Week",
  BILLABLE_HOURS: "Billable Hours",
  LIVE_LOGIN: "Live Login Activity",
};